export default {
  primary: {
    backgroundColor: 'secondary',
    color: 'light',
    border: 'solid 2px',
    borderColor: 'secondary',
    borderRadius: '0px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'bold',
    borderRadius: '500px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '1rem',
    ':hover': {
      backgroundColor: 'primary',
      borderColor: 'primary',
      opacity: '0.8'
    }
  },
  secondary: {
    backgroundColor: 'primary',
    color: 'white',
    borderRadius: '30px',
    border: 'solid 2px',
    borderColor: 'primary',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: ['0.9rem', '', '1rem'],
    fontFamily: 'body',
    textAlign: 'center',
    justifyContent: 'center',
    ':hover': {
      backgroundColor: 'primary',
      color: 'white'
    }
  }
}
